import Vue from 'vue';
import { Toast } from 'vant';
import Clipboard from 'clipboard';
import { currency, dateFormat, dateNow, dateParse, isUndef, overlongTextProcessing, placeholder, securityText } from '../utils';
import ListSection from '@/components/list/listSection.vue';
import ListTitle from '@/components/list/listTitle.vue';
import ListItem from '@/components/list/listItem.vue';
import ListFooter from '@/components/list/listFooter.vue';
import DaisySpinner from '@/components/spinner/daisy.vue';
import SpinnerMobileButton from '@/components/button/spinnerMobileButton.vue';
import ROSwitch from '@/components/switch/switch.vue';
import ItemTwoUploader from '@/components/form/itemTwoUploader.vue';
import CustomCascader from '@/components/form/customCascader.vue';
import EmptyHint from '@/components/extra/emptyHint.vue';
import PreviewImageList from '@/components/extra/previewImageList.vue';
import PreviewImage from '@/components/extra/previewImage.vue';
import PreviewBg from '@/components/extra/previewBg.vue';
import SlideNav from '@/components/nav/slideNav.vue';
import CommonNav from '@/components/nav/commonNav.vue';
import Brand from '@/features/activity/brand.vue';
import LayoutBrand from '@/components/layout/brand.vue';
import SectionTitle from '@/features/team/sectionTitle.vue';
import { showImagePopup } from './popup/imagePopup';
import tryImage from './directive/tryImage';

export default function() {
    // 注册全局过滤器
    Vue.filter('dateParse', dateParse);
    Vue.filter('dateFormat', dateFormat);
    Vue.filter('placeholder', placeholder);
    Vue.filter('currency', currency);
    Vue.filter('securityText', securityText);
    Vue.filter('dateDisplay', (val: string) => {
        if (isUndef(val)) {
            return val;
        }
        const date = dateParse(val);
        const now = dateNow();
        const interval = (now.valueOf() - date.valueOf()) / 60000; // 分钟数
        if (interval <= 1) {
            return '刚刚';
        } else if (interval < 60) {
            return Math.floor(interval) + '分钟前';
        } else if (interval < 60 * 24) {
            return Math.floor(interval / 60) + '小时前';
        } else if (interval < 60 * 24 * 3) {
            return Math.floor(interval / 60 / 24) + '天前';
        } else {
            return dateFormat(date);
        }
    });
    Vue.filter('overlongTextProcessing', overlongTextProcessing);
    Vue.filter('signinStatus', (status: SignIn.Status) => {
        switch (status) {
        case 'normal':
            return '今日待审核';
        case 'accepted':
            return '已通过';
        case 'rejected':
            return '未通过';
        }
    });
    Vue.filter('activityStatus', (status: Activity.Status) => {
        switch (status) {
        case 'pending':
            return '未开始';
        case 'sign_up':
            return '报名中';
        case 'sign_in':
            return '打卡中';
        case 'finished':
            return '已结束';
        }
    });

    Vue.directive('focus', {
        inserted(el) {
            if (el.dataset.focus && el.dataset.focus === 'true') {
                el.focus();
            }
        },
    });
    Vue.directive('tryimage', tryImage);
    Vue.directive('clipboard', {
        bind(el, binding) {
            const clipboard = new Clipboard(el, {
                text: () => {
                    return binding.value;
                },
            });
            clipboard.on('success', () => {
                Toast('复制成功');
            });
            clipboard.on('error', () => {
                Toast('复制失败');
            });
            // @ts-ignore
            el.__clipboard = clipboard;
        },
        unbind(el) {
            // @ts-ignore
            const clipboard = el.__clipboard as Clipboard | null;
            if (clipboard) {
                clipboard.destroy();
                // @ts-ignore
                el.__clipboard = null;
            }
        },
    });

    Vue.component('ListTitle', ListTitle);
    Vue.component('ListSection', ListSection);
    Vue.component('ListItem', ListItem);
    Vue.component('ListFooter', ListFooter);
    Vue.component('DaisySpinner', DaisySpinner);
    Vue.component('SpinnerMobileButton', SpinnerMobileButton);
    Vue.component('ROSwitch', ROSwitch);
    Vue.component('SlideNav', SlideNav);
    Vue.component('CommonNav', CommonNav);
    Vue.component('Brand', Brand);
    Vue.component('PreviewImageList', PreviewImageList);
    Vue.component('PreviewImage', PreviewImage);
    Vue.component('PreviewBg', PreviewBg);
    Vue.component('LayoutBrand', LayoutBrand);
    Vue.component('ItemTwoUploader', ItemTwoUploader);
    Vue.component('CustomCascader', CustomCascader);
    Vue.component('EmptyHint', EmptyHint);
    Vue.component('SectionTitle', SectionTitle);

    Vue.prototype.$showImagePopup = showImagePopup;
    Vue.prototype.$tempImg = 'https://static.playground.forzoom.tech/meta/square/1.jpg';
}
